/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesPipeSeriesStatus200, GetUsersPreferencesPipeSeriesStatus204, GetUsersPreferencesPipeSeriesStatus401 } from '../types/GetUsersPreferencesPipeSeries'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesPipeSeries } from '../clients/getUsersPreferencesPipeSeries'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersPreferencesPipeSeriesQueryKey = () => [{ url: '/users/preferences/pipe-series/' }] as const

type GetUsersPreferencesPipeSeriesQueryKey = ReturnType<typeof getUsersPreferencesPipeSeriesQueryKey>

export function getUsersPreferencesPipeSeriesQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesPipeSeriesQueryKey()
  return queryOptions<GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>, GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesPipeSeries({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/pipe-series/}
 */
export function useGetUsersPreferencesPipeSeries<TData = GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, TQueryData = GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, TQueryKey extends QueryKey = GetUsersPreferencesPipeSeriesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetUsersPreferencesPipeSeriesStatus200 | GetUsersPreferencesPipeSeriesStatus204, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesPipeSeriesQueryKey()

  const queryResult = useQuery({
   ...getUsersPreferencesPipeSeriesQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesPipeSeriesStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
